<template>
  <el-popover
      v-model="enableEditEmail"
      placement="top"
      width="400"
      trigger="click">
    <div v-loading="loading">
      <el-form>
        <el-form-item label="Set new email">
          <el-input
              v-model="newEmail"
              size="small"
              type="email"
              :placeholder="customer.email"
              inline-message="true"
              style="width: 100%"
              :disabled="loading"
              clearable />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button
              type="primary"
              size="small"
              :disabled="loading"
              @click="saveCustomerEmail">
            Save
          </el-button>
          <el-button
              size="small"
              @click="enableEditEmail = false">
            Cancel
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-button
        slot="reference"
        type="text"
        style="color: #f56c6c; padding: 0px; font-size: 14px;">
      (Change)
    </el-button>
  </el-popover>
</template>

<script>
import { get } from "lodash";

export default {
  name: "CustomerEmailForm",
  props: {
    customer: {
      type: Object,
      required: true,
    },
    updateFn: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      enableEditEmail: false,
      newEmail: null,
      loading: false,
    };
  },
  methods: {
    saveCustomerEmail() {
      this.loading = true;
      this.updateFn({
        id: this.customer.id,
        email: this.newEmail,
      })
        .then((response) => {
          this.customer.email = this.newEmail;
          this.newEmail = null;
          this.enableEditEmail = false;
          this.$message({
            showClose: true,
            message: "Email updated successfully",
            type: "success",
          });
        })
        .catch((error) => {
          let parsedMessage = this.parseErrorResponse(error);
          this.$message({
            showClose: true,
            message: parsedMessage,
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    parseErrorResponse(error) {
      let current_error = get(
        error,
        "data.message.table.message",
        "Error updating email"
      );
      if (current_error.match(/Updating email to something that already exist/))
        return "That email address is already in use by another ring account";
      else return current_error;
    },
  },
};
</script>
